import AdminLayout from "@/components/layout/AdminLayout";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const ROLES = [
  { name: "Admin", perms: ["users:*", "loans:*", "kyc:*", "cms:*", "reports:read"] },
  { name: "Underwriter", perms: ["loans:read", "loans:decide", "kyc:review", "reports:read"] },
  { name: "Ops", perms: ["disbursement:*", "repayment:*", "customers:read"] },
  { name: "Support", perms: ["customers:read", "tickets:*"] },
  { name: "Customer", perms: ["self:*"] },
];

export default function AdminRoles() {
  return (
    <AdminLayout>
      <div className="space-y-6">
        <div>
          <div className="text-xs uppercase tracking-widest text-primary font-semibold">Access</div>
          <h1 className="font-display text-3xl mt-2">Roles & Permissions</h1>
        </div>
        <Card className="p-0 overflow-hidden">
          <Table>
            <TableHeader><TableRow><TableHead>Role</TableHead><TableHead>Permissions</TableHead></TableRow></TableHeader>
            <TableBody>
              {ROLES.map((r) => (
                <TableRow key={r.name}>
                  <TableCell className="font-medium">{r.name}</TableCell>
                  <TableCell className="text-sm">
                    <div className="flex flex-wrap gap-2">{r.perms.map((p) => <span key={p} className="text-xs px-2 py-1 rounded-full bg-primary/10 text-primary">{p}</span>)}</div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Card>
      </div>
    </AdminLayout>
  );
}
